import { onDocumentReady } from '@theme/utilities';

class CollectionsFilter {
  constructor() {
    this.tabs = document.querySelectorAll('[data-filter]');
    this.collections = document.querySelectorAll('[data-id]');
    this.activeFilter = null;
    this.init();
  }

  init() {
    if (this.tabs.length === 0 || this.collections.length === 0) return;
    this.bindEvents();
    this.setActiveTab(0);
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const filterValue = tab.getAttribute('data-filter');
        if (filterValue) {
          this.filterCollections(filterValue);
          this.setActiveTabByFilter(filterValue);
        }
      });
    });
  }

  /**
   * Filters collections based on the provided filter value.
   * @param {string} filterValue - The filter value to apply.
   */
  filterCollections(filterValue) {
    this.activeFilter = filterValue;

    this.collections.forEach(collection => {
      const collectionTags = collection.getAttribute('data-id');

      if (filterValue === 'all' || (collectionTags && collectionTags.includes(filterValue))) {
        collection.classList.remove('filtered-out');
      } else {
        collection.classList.add('filtered-out');
      }
    });
  }

  /**
   * Sets the active tab by index.
   * @param {number} index - The index of the tab to activate.
   */
  setActiveTab(index) {
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('active');
        const filterValue = tab.getAttribute('data-filter');
        if (filterValue) {
          this.filterCollections(filterValue);
        }
      } else {
        tab.classList.remove('active');
      }
    });
  }

  /**
   * Sets the active tab by filter value.
   * @param {string} filterValue - The filter value of the tab to activate.
   */
  setActiveTabByFilter(filterValue) {
    this.tabs.forEach(tab => {
      if (tab.getAttribute('data-filter') === filterValue) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
  }

  /**
   * Gets the currently active filter.
   * @returns {string | null} The active filter value.
   */
  getActiveFilter() {
    return this.activeFilter;
  }

  resetFilter() {
    this.filterCollections('all');
    this.setActiveTabByFilter('all');
  }
}

function initCollectionsPage() {
  new CollectionsFilter();
}

onDocumentReady(() => {
  const templateName = Theme?.template?.name;
  if (templateName !== 'collection' && templateName !== 'list-collections') return;

  initCollectionsPage();
});
